import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getAccount } from "Redux/Actions/GetAccountAction";
import MODALMESSAGES from "Constants/Messages";
import AppConstants from "Constants/AppConstants";

import { getProductFromVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import Repayment from "./Repayment";
import { updateLendingProduct } from "Components/LoanDetails/Actions/LoanDetailsAction";
import { getApplicationProperty } from "../JointApplicant/Actions/JointApplicantAction";
import Disbursement from "../Disbursement/Disbursement";
import InveriteAccountList from "../Inverite/InveriteAccountList";
import { callCreateInveriteAccountList } from "Components/Inverite/Actions/InveriteAction";
import { HTTP_STATUS } from "Communication/Constants";
import { getApplicantBankingProductList } from "../AccountInformation/Actions/AccountInformationAction";
import { updateProductToVault } from "../MarketPlace/Action/MarketPlaceAction";
import STRINGS from "../../Constants/Strings";
import { checkEsignDoc } from "../Signature/Actions/SignatureAction";

class RepaymentContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      choice: "",
      showModal: false,
      modalType: "",
      modal: {
        title: "",
        description: "",
      },
      repayment: {},
      accountList: [],
      productList: [],
      accountError: [],
      otherAccountError: [],
    };
  }

  componentDidMount() {
    const {
      products,
      getActiveProduct,
      bankingProductList,
      doGetApplicantBankingProductList,
      finInfo,
    } = this.props;

    const activeProduct = getActiveProduct(products);
    if (activeProduct && finInfo?.demandProductCodes) {
      if (activeProduct.accountList) {
        this.setState({
          accountList: activeProduct.accountList,
        });
      }
      if (activeProduct.repayment) {
        this.setState({
          repayment: activeProduct.repayment,
        });
      }
      if (bankingProductList && bankingProductList.length > 0) {
        const productList = bankingProductList.products?.filter((product) =>
          finInfo.demandProductCodes?.includes(product.productCode)
        );
        console.log("productList", productList);
        this.setState({
          productList,
        });
      } else {
        doGetApplicantBankingProductList(
          activeProduct.applicantId,
          (response) => {
            const productList = response.products?.filter((product) =>
              finInfo.demandProductCodes?.includes(product.productCode)
            );
            this.setState({
              productList,
            });
          }
        );
      }
    }
    console.log(activeProduct);
  }

  componentDidUpdate(prevProps) {
    const {
      products,
      getActiveProduct,
      bankingProductList,
      doGetApplicantBankingProductList,
      finInfo,
    } = this.props;

    if (finInfo !== prevProps.finInfo) {
      const activeProduct = getActiveProduct(products);
      if (activeProduct) {
        if (activeProduct.accountList) {
          this.setState({
            accountList: activeProduct.accountList,
          });
        }
        if (activeProduct.repayment) {
          this.setState({
            repayment: activeProduct.repayment,
          });
        }
        if (bankingProductList && bankingProductList.length > 0) {
          const productList = bankingProductList.products?.filter((product) =>
            finInfo.demandProductCodes?.includes(product.productCode)
          );
          console.log("productList", productList);
          this.setState({
            productList,
          });
        } else {
          doGetApplicantBankingProductList(
            activeProduct.applicantId,
            (response) => {
              const productList = response.products?.filter((product) =>
                finInfo.demandProductCodes?.includes(product.productCode)
              );
              this.setState({
                productList,
              });
            }
          );
        }
      }
    }
  }

  updateRepayment = (repayment) => {
    console.log("updateRepayment", repayment);
    if (repayment) {
      if (
        repayment.accountType === AppConstants.ACCOUNT_TYPE.OTHER &&
        repayment.selectedOtherAccount
      ) {
        this.setState({
          repayment,
          accountError: [],
          otherAccountError: [],
        });
      } else {
        this.setState({
          repayment,
          accountError: [],
        });
      }
    }
  };

  handleChange = () => {};

  handleContinue = () => {
    const { repayment, accountList } = this.state;
    const {
      continuehandler,
      doUpdateLendingProduct,
      products,
      getActiveProduct,
      doGetApplicationProperty,
      applicantData,
      doUpdateProductToVault,
      doCheckEsignDoc,
    } = this.props;
    console.log("handleContinue", repayment);
    const activeProduct = getActiveProduct(products);
    let payLoad = { RepaymentComment: repayment.comment };
    if (repayment.accountType) {
      if (repayment.accountType === AppConstants.ACCOUNT_TYPE.OTHER) {
        if (repayment.selectedOtherAccount) {
          const selectedAccount = accountList.find(
            (acct) => acct.account === repayment.selectedOtherAccount
          );
          payLoad = {
            ...payLoad,
            LPPaymentSourceDetails: {
              PaymentSourceType: "external account",
              ExternalPaymentInst: selectedAccount.institution,
              ExternalPaymentTransit: selectedAccount.transit,
              ExternalPaymentAccountNumber: repayment.selectedOtherAccount,
              ExternalPaymentAccountName: selectedAccount.account_description,
              ExternalPaymentInstName: selectedAccount.bank,
            },
          };
        } else {
          this.setState({
            otherAccountError: [STRINGS.REPAYMENT.ERROR.REQUIRED_OTHER],
          });
          return;
        }
      } else {
        payLoad = {
          ...payLoad,
          LPPaymentSourceDetails: {
            PaymentSourceType: "cu account",
            CUPaymentAccountType: "",
            CUPaymentAccountNumber: repayment.basicDetails.acctNo,
            // CUPaymentSub: repayment.basicDetails.sub,
            CUPaymentBranchShortName: repayment.basicDetails.branch,
          },
        };
      }
      doUpdateLendingProduct(
        activeProduct.applicationId,
        activeProduct.doximProductId,
        payLoad,
        (res) => {
          console.log(res);
          products[0].repayment = repayment;
          doUpdateProductToVault(products, () => {
            doCheckEsignDoc(activeProduct.applicationId, () => {
              doGetApplicationProperty(
                { applicationId: activeProduct.applicationId },
                (currentApplication) => {
                  if (
                    currentApplication.inReview ||
                    currentApplication.uploadedAt
                  ) {
                    this.setState({
                      showModal: true,
                      modalType: AppConstants.MODALTYPE.SUCCESS,
                      modal: {
                        title: MODALMESSAGES.REPAYMENT.CONGRATS_TITLE.split(
                          AppConstants.TEMPLATE.NAME
                        ).join(applicantData.member.name),
                        description: MODALMESSAGES.REPAYMENT.CONGRATS_MESSAGE.split(
                          AppConstants.TEMPLATE.NAME
                        ).join(applicantData.member.name),
                      },
                    });
                  } else {
                    continuehandler("", AppConstants.APPLICATIONSTEP.REPAYMENT);
                  }
                }
              );
            });
          });
        }
      );
    } else {
      this.setState({
        accountError: [STRINGS.REPAYMENT.ERROR.REQUIRED],
      });
    }
  };

  handlePopupModalBtnClick = () => {
    console.log("handlePopupModalBtnClick");
    const { continuehandler } = this.props;
    continuehandler({}, AppConstants.APPLICATIONSTEP.REPAYMENT);
  };

  openInverite = () => {
    console.log("openInverite");
    const { doCreateInveriteAccountList } = this.props;
    doCreateInveriteAccountList((response) => {
      console.log(response);
      if (response.status === HTTP_STATUS.OK) {
        sessionStorage.setItem(
          AppConstants.SESSION.INVERITE_ACCOUNTLIST_REQUEST_GUID,
          response.data.requestGuid
        );
        this.setState({
          iframeModal: true,
          iframeUrl: response.data.iframeUrl,
        });
      }
    });
  };

  processInverite = (data) => {
    const { doUpdateProductToVault, products } = this.props;
    const { repayment } = this.state;
    console.log("processInverite", data);
    const updateAccountList = data.accountList.map((acct) => {
      return {
        account: acct.account,
        account_description: acct.account_description,
        bank: acct.bank,
        institution: acct.institution,
        membership_number: acct.membership_number,
        routing_code: acct.routing_code,
        transit: acct.transit,
        type: acct.type,
      };
    });
    products[0].accountList = updateAccountList;
    doUpdateProductToVault(products, () => {
      this.setState({
        iframeModal: false,
        accountList: updateAccountList,
        repayment: {
          ...repayment,
          accountType: AppConstants.ACCOUNT_TYPE.OTHER,
        },
      });
    });
  };

  closeInveriteWindow = () => {
    this.setState({
      iframeModal: false,
    });
  };

  render() {
    const {
      choice,
      modal,
      modalType,
      showModal,
      iframeModal,
      iframeUrl,
      accountList,
      repayment,
      productList,
      accountError,
      otherAccountError,
    } = this.state;
    const { getDataFromServer, handleBack, steps, activeStepID } = this.props;

    return (
      <>
        <Repayment
          handleContinue={this.handleContinue}
          handleChange={this.handleChange}
          getDataFromServer={getDataFromServer}
          choice={choice}
          handleBack={handleBack}
          steps={steps}
          activeStepID={activeStepID}
          type={modalType}
          modal={modal}
          showModal={showModal}
          toggleModal={this.toggleModal}
          handlePopupModalBtnClick={this.handlePopupModalBtnClick}
          openInverite={this.openInverite}
          accountList={accountList}
          repayment={repayment}
          updateRepayment={this.updateRepayment}
          productList={productList}
          accountError={accountError}
          otherAccountError={otherAccountError}
          iframeModal={iframeModal}
        />
        {iframeModal && (
          <InveriteAccountList
            iframeUrl={iframeUrl}
            iframeModal={iframeModal}
            toggleModal={this.toggleModal}
            showModal={iframeModal}
            popupBtnClick={this.toggleModal}
            processInverite={this.processInverite}
            closeBtnClick={this.closeInveriteWindow}
          />
        )}
      </>
    );
  }
}

RepaymentContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  finInfo: PropTypes.oneOfType([PropTypes.object]),
};

RepaymentContainer.defaultProps = {
  steps: [],
  activeStepID: -1,
  finInfo: {},
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  applicantData: state.ApplicationReducer.response,
  bankingProductList: state.AccountInformationReducer.bankingProductList,
  finInfo: state.MarketplaceReducer.finInfo,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doUpdateLendingProduct: (
      applicationId,
      doximProductId,
      payLoad,
      callback
    ) =>
      dispatch(
        updateLendingProduct(applicationId, doximProductId, payLoad, callback)
      ),
    doGetApplicationProperty: (request, callback) =>
      dispatch(getApplicationProperty(request, callback)),
    doCreateInveriteAccountList: (callback) =>
      dispatch(callCreateInveriteAccountList(callback)),
    doGetApplicantBankingProductList: (applicantId, callback) =>
      dispatch(getApplicantBankingProductList(applicantId, callback)),
    doUpdateProductToVault: (vaultProductList, callback) =>
      dispatch(updateProductToVault(vaultProductList, callback)),
    doCheckEsignDoc: (applicantId, callback) =>
      dispatch(checkEsignDoc(applicantId, callback)),
  };
};

const RepaymentWrapper = withApplicantHOC(RepaymentContainer);

export default connect(mapStateToProps, mapDispatchToProps)(RepaymentWrapper);
